/* diwali26 claim bar.
 *
 * No backend. The coupon's own usage limit is the real cap; this script applies the
 * code to the visitor's cart and keeps a 20-minute hold on this device. The hold is
 * honest about what it is: the price is applied here for 20 minutes, not reserved for
 * anyone. If the cap runs out meanwhile, checkout rejects the code and the next page
 * load shows "all claimed".
 */
(function () {
  "use strict";

  var root = document.querySelector("[data-dw26]");
  if (!root || root.dataset.dw26Booted) return;
  root.dataset.dw26Booted = "1";

  var D = root.dataset;
  var HANDLE = D.handle;
  var CAP = parseInt(D.cap, 10);
  var HOLD_MS = (parseInt(D.holdMinutes, 10) || 20) * 60 * 1000;
  var KEY = "dw26:" + HANDLE;
  var UTM_KEY = "dw26:utm";

  var $ = function (sel) { return root.querySelector(sel); };
  var countEl = $("[data-dw26-count]");
  var fillEl = $("[data-dw26-fill]");
  var nowEl = $("[data-dw26-now]");
  var noteEl = $("[data-dw26-note]");
  var priceEl = $("[data-dw26-price]");
  var expiredEl = $("[data-dw26-expired]");
  var scarcityEl = $("[data-dw26-scarcity]");
  var actionEl = $("[data-dw26-action]");

  // localStorage throws in some privacy modes; the widget must still render.
  function readStore(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function writeStore(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function dropStore(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  function readSession(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function writeSession(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  var params = new URLSearchParams(window.location.search);

  // --- preview gate -----------------------------------------------------------
  // The sale is not switched on for customers yet. Liquid rendered the bar hidden;
  // only a visitor holding the dev token gets to see it, and nobody else can claim
  // because every coupon is still inactive.
  // No gate here any more. While the sale is gated liquid renders this bar hidden and
  // without a code, and dw26-unlock.js is what reveals it and fills the code in. Booting
  // regardless avoids a race: this script and the unlock script are both deferred, and
  // whichever lands first, the button cannot be pressed until the bar is visible.

  // --- utm, carried to the order as a cart attribute --------------------------
  var utm = params.get("utm_content");
  if (utm) writeSession(UTM_KEY, utm);

  // --- clock, with a dev-only override ---------------------------------------
  // preview_time is honoured only inside the theme editor or with the dev token, so a
  // customer cannot talk the widget into opening early.
  function clockNow() {
    var allowed =
      (window.Shopify && window.Shopify.designMode) ||
      window.__dw26Unlocked === true;
    var pv = params.get("preview_time");
    if (!allowed || !pv) return Math.floor(Date.now() / 1000);

    // Named states, because a hand-typed ISO string is easy to get wrong.
    var listAt = parseInt(D.listAt, 10);
    var startsAt = parseInt(D.startsAt, 10);
    var endsAt = parseInt(D.endsAt, 10);
    var named = {
      presale: listAt - 86400,
      list: listAt + 3600,
      live: startsAt + 86400,
      ended: endsAt + 60,
    };
    if (Object.prototype.hasOwnProperty.call(named, pv.toLowerCase())) {
      return named[pv.toLowerCase()];
    }

    // A "+" in a query string decodes to a space, so "...T10:00:00+05:30" arrives
    // as "...T10:00:00 05:30" and fails to parse. Repair it rather than silently
    // falling back to the real clock, which looks like the override being ignored.
    var t = Date.parse(pv);
    if (isNaN(t)) t = Date.parse(pv.replace(/ (\d{2}:\d{2})$/, "+$1"));
    if (isNaN(t)) {
      console.warn("[dw26] preview_time not understood:", pv, "- use live/presale/list/ended");
      return Math.floor(Date.now() / 1000);
    }
    return Math.floor(t / 1000);
  }

  // --- early access -----------------------------------------------------------
  // Liquid always renders the list window as presale. The token is read only here.
  // Early access is no longer a url token that flips this widget's state: it is a
  // password that decrypts the code and reveals the bar (dw26-unlock.js). What is left
  // here is purely the clock, the same for everyone who can see the bar at all.
  var hasEarly = false;

  function resolveState() {
    var t = clockNow();
    if (t > parseInt(D.endsAt, 10)) return "ended";
    if (parseInt(D.left, 10) <= 0) return "soldout";
    if (t >= parseInt(D.startsAt, 10)) return "live";
    if (t >= parseInt(D.listAt, 10) && hasEarly) return "live";
    return D.state === "soldout" ? "soldout" : D.state;
  }

  // --- the hold ---------------------------------------------------------------
  function heldUntil() {
    var raw = readStore(KEY);
    if (!raw) return 0;
    var n = parseInt(raw, 10);
    if (isNaN(n) || n <= Date.now()) { dropStore(KEY); return 0; }
    return n;
  }

  // Liquid only renders the yellow claim button when the SERVER clock says live. The
  // early-token upgrade and the post-expiry reset both have to dress it themselves, or
  // they leave a plain black button that reads like a second buy now.
  function dressAsClaim(el) {
    if (!el) return;
    el.disabled = false;
    el.classList.remove("dw26__action--quiet");
    el.classList.add("dw26__action--claim");
    el.textContent = D.saveMoney ? "claim now \u00b7 " + D.saveMoney + " off" : "claim now";
  }

  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function mmss(ms) {
    var s = Math.max(0, Math.round(ms / 1000));
    return pad(Math.floor(s / 60)) + ":" + pad(s % 60);
  }

  // --- paint ------------------------------------------------------------------
  function paintClaimed(claimed) {
    if (!countEl) return;
    countEl.textContent = claimed + " / " + CAP + " claimed";
    if (fillEl) fillEl.style.width = Math.min(100, Math.round((claimed / CAP) * 100)) + "%";
    var left = CAP - claimed;
    if (left <= CAP * 0.25 && left > 0 && scarcityEl) {
      scarcityEl.textContent = "fewer than " + Math.ceil(left / 50) * 50 + " left";
      root.dataset.scarce = "true";
    }
  }

  function paintHeld(until) {
    root.dataset.expired = "false";
    if (expiredEl) expiredEl.style.display = "none";
    if (nowEl) nowEl.textContent = D.saleMoney;
    var wasEl = $("[data-dw26-was]");
    if (wasEl) wasEl.textContent = D.oldMoney;
    if (noteEl) noteEl.textContent = "yours for the next 20 minutes";

    if (!actionEl) return;
    actionEl.disabled = true;
    actionEl.classList.remove("dw26__action--claim");
    actionEl.classList.add("dw26__action--quiet");
    (function tick() {
      var remain = until - Date.now();
      if (remain <= 0) return expire();
      actionEl.textContent = "claimed · " + mmss(remain) + " to checkout";
      window.setTimeout(tick, 1000);
    })();
  }

  function expire() {
    dropStore(KEY);
    root.dataset.expired = "true";
    if (expiredEl) expiredEl.style.display = "block";
    // Back to the unclaimed live look: sale price big, normal price struck, qualifier on.
    if (nowEl) nowEl.textContent = D.saleMoney;
    var wasEl = $("[data-dw26-was]");
    if (wasEl) wasEl.textContent = D.oldMoney;
    if (noteEl) noteEl.textContent = "when you claim";
    if (actionEl && parseInt(D.left, 10) > 0) dressAsClaim(actionEl);
  }

  // --- claiming ---------------------------------------------------------------
  function trackClaim() {
    var value = parseInt(D.sale, 10);
    try {
      if (window.fbq) {
        window.fbq("trackCustom", "Claim", {
          content_ids: [D.sku],
          content_type: "product",
          value: value,
          currency: "INR",
        });
      }
    } catch (e) {}
    try {
      if (window.gtag) window.gtag("event", "claim", { items: [{ item_id: D.sku }], value: value, currency: "INR" });
      if (window.dataLayer) window.dataLayer.push({ event: "claim", item_id: D.sku, value: value, currency: "INR" });
    } catch (e) {}
  }

  function stampUtm() {
    var v = readSession(UTM_KEY);
    if (!v) return Promise.resolve();
    // A cart attribute rides the order through Shopflo, so claims can be read per ad
    // off the orders themselves rather than from a separate service.
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { claim_utm: v } }),
    }).catch(function () {});
  }

  function claim() {
    if (!actionEl) return;
    actionEl.disabled = true;
    actionEl.textContent = "applying";

    // Shopflo runs this store's checkout but reads Shopify's cart and, per the merchant
    // config, Shopify's discounts (discounts.mode = SHOPIFY). Hitting /discount/<code>
    // sets the discount on the Shopify cart, which is what Shopflo then picks up.
    fetch("/discount/" + encodeURIComponent(D.code) + "?redirect=/products/" + HANDLE, {
      credentials: "same-origin",
    })
      .then(function () { return stampUtm(); })
      .then(function () {
        var until = Date.now() + HOLD_MS;
        writeStore(KEY, String(until));
        paintClaimed(Math.min(parseInt(D.claimed, 10) + 1, CAP));
        paintHeld(until);
        trackClaim();
        var buy = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
        if (buy && buy.scrollIntoView) buy.scrollIntoView({ behavior: "smooth", block: "center" });
      })
      .catch(function () {
        dressAsClaim(actionEl);
      });
  }

  // --- boot -------------------------------------------------------------------
  var state = resolveState();

  if (state === "ended") {
    dropStore(KEY);
    root.hidden = true;
    return;
  }

  // The early-token visitor gets the live widget that liquid would not render.
  if (state === "live" && D.state !== "live" && actionEl) {
    dressAsClaim(actionEl);
    if (noteEl) noteEl.textContent = "when you claim";
    var early = root.querySelector(".dw26__early");
    if (early) early.remove();
    // Liquid printed the presale label because it renders the list window as presale.
    // Once the widget is live for this visitor the label is wrong, so it goes.
    var label = root.querySelector(".dw26__label");
    if (label) label.remove();
    root.dataset.state = "live";
  }

  var until = heldUntil();
  if (until) {
    paintHeld(until);
  } else if (state === "live" && actionEl && actionEl.tagName === "BUTTON") {
    actionEl.addEventListener("click", claim);
  }

  if (state === "live" && actionEl && actionEl.tagName === "BUTTON" && !until) {
    actionEl.disabled = false;
  }
})();
